import { Box, Stack } from "@mui/material";
import React from "react";
import { MapLayout } from "./MapLayout";
import { ParlorDetailProps } from "../../../types";

export function ATypeMap({
  defaultParlor,
  latitude,
  longitude,
  companyname,
}: {
  defaultParlor?: ParlorDetailProps;
  latitude?: Number;
  longitude?: Number;
  companyname?: String;
}) {
  return (
    <Stack gap="8px">
      <Box component="h2" className="subtitle_16_b" margin={0}>
        {defaultParlor?.companyname || companyname} 위치
      </Box>
      <MapLayout
        parlor={defaultParlor}
        latitude={latitude}
        longitude={longitude}
        companyname={companyname}
      />
    </Stack>
  );
}
